export * from "./gaussianSplattingMeshBase.pure";

import "core/Meshes/thinInstanceMesh";
